import { useEffect, useState, RefObject } from 'react'

export const usePLPScrolling = (filtersRef: RefObject<HTMLDivElement>) => {
    const [isHidden, setIsHidden] = useState(false)

    useEffect(() => {
        const el = filtersRef.current
        if (!el) return

        const filterTop = el.offsetTop
        let lastScrollY = window.scrollY

        const handleScroll = () => {
            const currentScrollY = window.scrollY
            setIsHidden(
                currentScrollY > lastScrollY && currentScrollY > filterTop
            )
            lastScrollY = currentScrollY
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [filtersRef])

    return { isHidden }
}
